import { render, staticRenderFns } from "./dueForCalving.vue?vue&type=template&id=15b3e168&scoped=true&"
import script from "./dueForCalving.vue?vue&type=script&lang=js&"
export * from "./dueForCalving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b3e168",
  null
  
)

export default component.exports